<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="heading">
  <span class="select-attributes" [innerHTML]="reviewEditRuleData.mode"></span>
  <tr-rule-name-type [ruleName]="reviewEditRuleData.name"
                     [ruleType]="rulesCategory"></tr-rule-name-type>
</div>

<div class="review-rules">
  <form [formGroup]="reviewEditRuleForm" *ngIf="reviewEditRuleForm">
    <div class="sdps-p-bottom_large sdps-p-top_large step-border-box select-rule-type ">
      <div class="sdps-grid-container sdps-wrap">
        <div class="sdps-row">
          <div class="rule-type-textbox col-6" [ngClass]="{'invalidField': (reviewEditRuleForm.get('reviewRuleName').value && reviewEditRuleForm.get('reviewRuleName').invalid)}">
           <p-floatlabel variant="in">
              <input type="text" name="ruleName" [maxlength]="100" formControlName="reviewRuleName" value="reviewEditRuleForm.get('reviewRuleName').value"
              emsAlphaNumericSpecialCharacterValidation emsCharacterLimit
                     [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                     (emsCharacterLimitCheck)="showCharLimit = $event" pInputText/>
              <label>{{emtrConst.rulesConstant.ruleName}}
                <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
              </label>

           </p-floatlabel>
          </div>
        </div>
        <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small" *ngIf="reviewEditRuleForm.get('reviewRuleName').value.trim().length > showCharLimit">{{emtrConst.rulesConstant.characterLimit}}
          <span class="character-limit">{{reviewEditRuleForm.get('reviewRuleName').value.trim().length}} /{{commonConstants.charLimitValues.hundredMaxLimit}}
          </span>
        </p>
      </div>
    </div>

    <!-- Display selected Justification for Override -->
    <ems-accordion [label]="emtrConst.rulesConstant.ruleGlobalConst.justification" class="disabled-button-icon" *ngIf="reviewEditRuleData.mode === this.emtrConst.rulesConstant.ruleGlobalConst.override">
      <div class="emtr-radio sdps-grid-container sdps-p-left_xx-large sdps-m-around_none sdps-p-vertical_small select-rule-type">
        <div class="sdps-grid sdps-m-around_none sdps-p-left_none" *ngFor="let justification of sharedConstant[businessUnit].overrideJustification">
          <p-radioButton class="col-2 radio-button" name="justification" [value]=justification [label]=justification
            formControlName="justification" (ngModelChange)="editRuleNameDescriptionNotes()"></p-radioButton>
            <label class="sdps-p-right_x-small" [innerHTML]="justification"></label>
        </div>
        <div class="sdps-p-left_small  col-4">
          <span class="p-float-label rule-type-textbox sdps-p-around_small" [ngClass]="{'input-disabled': reviewEditRuleForm.value.justification !== 'Other'}">
            <input type="text" name="others" maxlength="35" formControlName="otherInput" aria-label="Other justification" pInputText #step4_otherInput/>
          </span>
        </div>

      </div>
    </ems-accordion>

    <ems-accordion label='{{emtrConst.rulesConstant.selectDates}}'>
      <div class="p-g sdps-p-left_medium display-flex align-items-flex-start">
        <p-radioButton name="selectDate" [(ngModel)]="dateSelectionType" [ngModelOptions]="{standalone: true}" value='date' class="emtr-radio sdps-p-top_small">
        </p-radioButton>
        <tr-from-to-datepicker (calendarValidation)="calendarValidation($event)" [calendarForm]="reviewEditRuleForm.get('calendarForm')"
                                             (throwDateError)="displayErrorDate($event)"></tr-from-to-datepicker>
      </div>
    </ems-accordion>

    <ems-accordion label='{{emtrConst.rulesConstant.ruleAssign}}'>
      <div class="step-border-box sdps-p-around_large">
        <p-tabs [value]="activeIndex" *ngIf="!(reviewEditRuleData?.globalRule)" class="emtr-tab" [lazy]="true" [selectOnFocus]="true"
          (onChange)="onChangeTab($event)">
          <p-tablist>
            <p-tab [value]="0" (click)="activeIndex =0" [disabled]="shouldDisabledGroupsOrPlans">{{sharedConstant[businessUnit].employeeGrpOrPlan}}
            </p-tab>
            <p-tab [value]="1" (click)="activeIndex =1"
              [disabled]="shouldDisabledEmployeesOrParticipants">{{sharedConstant[businessUnit].employeeOrParticipant}}</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <ems-shared-manage-employee-group [showSelection]="true" [empGrpformData]="reviewEditRuleData.employeeGroups"
                (initialCount)='getInitialCount($event)' (rowSelected)="employeeRowSelected(true)"
                [tableCountData]="tableCountData" [employees]="employees" (paginateEmployeeList)="paginateEmployeeList($event)"
                (employeeGroups)="getDataEmpGrp($event)">
              </ems-shared-manage-employee-group>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <ems-shared-manage-employee-accounts [getOrgId]='orgId' [assignFormData]='reviewEditRuleData'
                [empAccformData]="reviewEditRuleData.employeeAccounts" [moduleType]='loadedModuleType'
                (rowSelected)="employeeRowSelected(true)" (modifiedSubAccounts)="getSubAccnts($event)"
                (selectedEmployeeAccounts)="getDataEmpAcc($event)"></ems-shared-manage-employee-accounts>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
        <p-tabs value="0" *ngIf="reviewEditRuleData?.globalRule && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid,'','')"
          class="emtr-tab" [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageRule.uuid, '', '')}"
          [selectOnFocus]="activeIndex" (onChange)="onChangeTab($event)">
          <p-tablist>
            <p-tab value="0" [disabled]="shouldDisabledMasterGroups">{{emtrConst.ruleSteps.step3.masterGrpTab}}</p-tab>
            <p-tab value="1" [disabled]="shouldDisabledMasterAccounts">{{emtrConst.ruleSteps.step3.clientsTab}}</p-tab>
          </p-tablist>
          <!-- Master Group Section -->
          <p-tabpanels>
            <p-tabpanel value="0">
              <ems-shared-master-groups [showMGPSelection]="true" [mstrGrpformData]="employeeGroups"
                [showActionBtn]="showActionBtn" [masterAcctList]="employees"
                (paginateMasterGrpList)="paginateEmployeeList($event)" (employeeGroups)="updatedMasterGrpData($event)"
                (rowSelected)="employeeRowSelected(true)" (selectedMasterGrp)="masterGrpData($event)"
                [tableCountData]="tableCountData">
              </ems-shared-master-groups>
            </p-tabpanel>

            <!-- Master Accounts Section -->
              <p-tabpanel value="1">
                <tr-client-selection-table (rowSelected)="employeeRowSelected(true)"
                  (selectedMasterAccounts)="updatedMasterAcc($event)" (unAssignSelectedMstrAccts)="unAssignMstrAccts = $event" [masterGroupMode] = "sharedService.groupType ? 'CREATE' : ''"
                  (selectedClients)="getSelectedClientData($event)"></tr-client-selection-table>
              </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
      </div>
    </ems-accordion>
    <div class="security-description-container">
      <ems-accordion label={{emtrConst.rulesConstant.descriptionNotesTitle}}>
        <tr-description-and-notes class="description-notes" [descriptionForm]="reviewEditRuleForm.get('descriptionForm')"></tr-description-and-notes>
      </ems-accordion>
    </div>
  </form>
</div>

<ems-step-wizard-buttons [showPreviousBtn]="true" [showCancelBtn]="true" [showActivateBtn]="true" [disableBtn]="((employeeGroups && employeeGroups.length > 0 || employeeAccounts && employeeAccounts.length > 0) &&  !reviewEditRuleForm.invalid && (reviewEditRuleForm.get('reviewRuleName').value.trim().length !== 0) ? '' :true) || dateError"
                         [disablePrevBtn]="(reviewEditRuleForm.get('descriptionForm').get('changeRequestId').value && reviewEditRuleForm.get('descriptionForm').get('changeRequestId').invalid) || (dateError && dateError.length > 0)" (activate)="activateRule()" (goToPrevious)="goToPrevious()" (closeBtn)="cancelCreateRule()" [disablePrevBtn]="dateError || this.isInValidFromDate || this.isInValidToDate || this.isPastFromDate || this.isPastToDate || ruleNameError"></ems-step-wizard-buttons>
